import { useState, useEffect } from "react"

export const useCollapseState = <T extends { coa_id: number }>( list: T[], storageKey: string) => {
  const [collapsed, setCollapsed] = useState<Record<number, boolean>>(() => {
    const saved = localStorage.getItem(storageKey)
    if (saved) {
      try {
        return JSON.parse(saved) as Record<number, boolean>
      } catch {
        return list.reduce((acc, item) => {
          acc[item.coa_id] = true
          return acc
        }, {} as Record<number, boolean>)
      }
    }
    return list.reduce((acc, item) => {
      acc[item.coa_id] = true
      return acc
    }, {} as Record<number, boolean>)
  })

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(collapsed))
  }, [collapsed, storageKey])

  const toggleCollapse = (id: number) => {
    setCollapsed(prev => ({
      ...prev,
      [id]: !prev[id]
    }))
  }

  const isCollapsed = (id: number) => !!collapsed[id]

  return { isCollapsed, toggleCollapse }
}
